import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditAcademicYear from '../../components/academicYears/FormAddEditAcademicYear';

const CreateAcademicYear = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAcademicYear />
        </WrapperSection>
    );
};

export default CreateAcademicYear;
